<script lang="ts">
import {defineComponent, PropType} from 'vue'
import GlobalInputCheckbox from "@global/global-elements/global-input-checkbox/global-input-checkbox.vue";
import {MediaGalleryAssetType} from "../types/MediaGalleryAssetType";

export default defineComponent({
    name: "MediaGalleryAsset",
    components: {GlobalInputCheckbox},
    props: {
        asset: {
            type: Object as PropType<MediaGalleryAssetType>,
            required: true
        },
    },
    computed: {
        suffix() {
            let suffix = this.asset.meta_type;
            if (this.asset.meta_width && this.asset.meta_height) {
                suffix += `, ${this.asset.meta_width}x${this.asset.meta_height}`
            }
            else if (this.asset.meta_filesize) {
                suffix += `, ${this.asset.meta_filesize}`
            }

            return suffix;
        },
        isSelected() {
            return this.$store.getters.isAssetSelected(this.asset.id)
        },
        checkboxLabel() {
            let label = this.asset.headline
            if (this.asset.subline) {
                label += `<br>${this.asset.subline}`
            }
            return label + '<br>';
        }
    },
    methods: {
        handleDetail() {
            this.$emit('showDetail', this.asset.id)
        }
    }
})
</script>

<template>
    <figure v-if="asset" class="media-gallery-asset">
<!--        Achtung: Bild-Quellen können auch kleiner sein "Anwendungsbild Möbel- und Innenausbau, Sitzbank (JPG, 360x180)"-->
        <div class="media-gallery-assets__image" @click="handleDetail">
            <img v-if="asset.thumbnail" :src="asset.thumbnail" alt="" />
            <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 160 160">
                <g fill="none" fill-rule="evenodd">
                    <path fill="#CCC" fill-rule="nonzero" d="M93 29H39v103h81V56z"/>
                    <path fill="#FFF" fill-rule="nonzero" d="M93 34v22h22v70H44V34z"/>
                    <path fill="#ABABAB" d="M71 94h59v22H71z"/>
                    <text fill="#000" font-size="15" font-weight="300" transform="translate(71 94)">
                        <tspan x="16" y="17">{{ asset.meta_type.toUpperCase() }}</tspan>
                    </text>
                </g>
            </svg>
        </div>
        <figcaption class="spacer-top-21">
            <global-input-checkbox :label="checkboxLabel" :value="isSelected" :label-suffix="suffix" @input="$store.dispatch('toggleAssetSelection', asset.id)"/>
        </figcaption>
    </figure>
</template>
